import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

import { Comment, Discussion, PanelMember } from "../../../../../models";
import { CommentVoteService, UserService } from "../../../../../services";

@Component({
  selector: "downvote-comment-button",
  templateUrl: "./downvote-comment-button.component.html",
  styleUrls: [
    "./downvote-comment-button.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DownvoteCommentButtonComponent {
  constructor(
    private commentVoteService: CommentVoteService,
    private router: Router,
    private userService: UserService
  ) {
    this.initializePNotify();
  }

  @Input() comment: Comment;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Output() onToggle = new EventEmitter<boolean>();
  public isSubmitting = false;

  public toggleDownvote(): void {
    if (
      this.discussion.community.isMember === true ||
      this.currentPanelMember
    ) {
      this.voteComment();
    } else {
      this.openNonMemberAlert();
    }
  }

  public voteComment() {
    this.isSubmitting = true;

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Downvote the comment if it isn't downvoted yet
      if (this.comment.voted !== null && !this.comment.voted.downVote) {
        this.updateVote(true);
      }
      // Otherwise,reverse the downvote of the comment
      else {
        this.updateVote(false);
      }
    });
  }

  public updateVote(emitValue: boolean) {
    this.commentVoteService.downvote(this.discussion, this.comment).subscribe(
      (data) => {
        this.isSubmitting = false;
        this.onToggle.emit(emitValue);
        this.notifyUser();
      },
      (err) => (this.isSubmitting = false)
    );
  }

  public openNonMemberAlert() {
    Swal.fire({
      title: "Askies, Sorry!",
      text: "Only members of this uMuzi can vote on comments, please ask a member to invite you",
      type: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Mxm ok!",
    });
  }

  public initializePNotify() {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  public notifyUser() {
    PNotify.info({
      title: "Hey!",
      titleTrusted: false,
      text: this.comment.voted.downVote
        ? "You downvoted: " + this.comment.body.substring(0, 50) + "..."
        : "You removed downvote: " + this.comment.body.substring(0, 50) + "...",
      textTrusted: false,
      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 3000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
      stack: {
        dir1: "down",
        firstpos1: 25,
      },
    });
  }
}
